import { render, staticRenderFns } from "./WoundVisit.vue?vue&type=template&id=546052db&scoped=true"
import script from "./WoundVisit.vue?vue&type=script&lang=ts"
export * from "./WoundVisit.vue?vue&type=script&lang=ts"
import style0 from "./WoundVisit.vue?vue&type=style&index=0&id=546052db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546052db",
  null
  
)

export default component.exports